import React, { Component } from 'react'
import Card from '../../../componentsMaterial/Card/Card.jsx'
import ChartAction from '../../../redux/chart/actions'
import Scrollbar from 'react-smooth-scrollbar'

// redux
import { connect } from 'react-redux'
import { Divider, Row, Col, Icon, Button } from 'antd'
import moment from 'moment'
class ToDoList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            forceupdate: 0,
        }
    }
    isCanGetAllTask = actions => {
        let bool = false
        actions.map(value => {
            if (value === 'TASK_VIEW') {
                bool = true
            }
        })
        return bool
    }
    componentDidMount() {
        console.log('didmount')
        if (this.props.userInfo) {
        }
    }
    componentWillReceiveProps(nextprops) {
        if (nextprops.userInfo !== this.props.userInfo) {
            if (
                this.isCanGetAllTask(nextprops.userInfo.actions) ||
                nextprops.userInfo.tier_id === 100
            ) {
                this.props.getListDataTaskAdmin(1, 20, 6, true)
            } else {
                console.log('nextprops.userInfo', nextprops.userInfo.uid)
                this.props.getListDataTaskUser(
                    nextprops.userInfo.uid,
                    1,
                    20,
                    6,
                    true
                )
            }
        }
    }
    getDataTodo = () => {
        let lstData = []
        if (this.props.dataTask) {
            this.props.dataTask.map(value => {
                if (value.status === 1 || value.status === 3) {
                    lstData.push(value)
                }
            })
        }
        return lstData
    }
    render() {
        console.log('dataTask', this.props.dataTask)
        return (
            <div style={{ width: '100%', fontFamily:'San Francisco' }}>
                <Card
                    style={{
                        backgroundImage: `url(${require('../../../resource/image/blur-bg.jpg')}`,
                        backgroundSize: 'initial',
                        backgroundPosition: 'center left',
                        height: 900,
                    }}
                >
                    <text
                        style={{
                            fontSize: 20,
                            color: 'white',
                            paddingLeft: 20,
                            paddingTop: 20,
                        }}
                    >
                        {' '}
                        Nhiệm vụ cần hoàn thành{' '}
                    </text>
                    <Divider />
                    <Scrollbar style={{ height: 750 }}>
                        {this.props.dataTask &&
                            this.getDataTodo().map(task => (
                                <a href={`/app/qbtask/project/${task.task_id}`}>
                                    <Row style={{ color: 'white' }}>
                                        <Col
                                            lg={18}
                                            md={18}
                                            sm={18}
                                            xs={24}
                                            style={{
                                                paddingLeft: 5,
                                                paddingRight: 10,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Icon
                                                    type="star"
                                                    theme="filled"
                                                    style={{
                                                        color: task.star
                                                            ? '#ED8A19'
                                                            : '#999999',
                                                        fontSize: 16,
                                                        verticalAlign: 'middle',
                                                        marginRight: 4,
                                                        cursor: 'pointer',
                                                    }}
                                                />{' '}
                                                {task.name}
                                            </div>
                                        </Col>
                                        <Col
                                            lg={6}
                                            md={6}
                                            sm={6}
                                            xs={24}
                                            style={{ paddingLeft: 5 }}
                                        >
                                            <text>
                                                {moment(
                                                    task.deadline * 1000
                                                ).format('DD/MM/YYYY')}
                                            </text>
                                        </Col>
                                    </Row>

                                    <Divider />
                                </a>
                            ))}
                    </Scrollbar>
                    {this.props.totalTask > this.props.pageNumber * 20 && (
                        <Button
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                            type="link"
                            onClick={() => {
                                if (
                                    this.isCanGetAllTask(
                                        this.props.userInfo.actions
                                    ) ||
                                    this.props.userInfo.tier_id === 100
                                ) {
                                    this.props.getListDataTaskAdmin(
                                        this.props.pageNumber + 1,
                                        20,
                                        6,
                                        false
                                    )
                                } else {
                                    this.props.getListDataTaskUser(
                                        this.props.userInfo.uid,
                                        this.props.pageNumber + 1,
                                        20,
                                        6,
                                        false
                                    )
                                }
                            }}
                        >
                            Xem thêm
                        </Button>
                    )}
                </Card>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        userInfo: state.auth.userInfo,
        dataTask: state.chartReducer.dataTask,
        pageNumber: state.chartReducer.pageNumber,
        totalTask: state.chartReducer.totalTask,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getListDataTaskAdmin: (page_number, page_size, deleted, isRefresh) => {
            dispatch(
                ChartAction.action.getListDataTaskAdmin(
                    page_number,
                    page_size,
                    deleted,
                    isRefresh
                )
            )
        },
        getListDataTaskUser: (
            uid,
            page_number,
            page_size,
            deleted,
            isRefresh
        ) => {
            dispatch(
                ChartAction.action.getListDataTaskUser(
                    uid,
                    page_number,
                    page_size,
                    deleted,
                    isRefresh
                )
            )
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ToDoList)
